import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPerguntas(id) {
        let url = `${api}/pesquisas/${id}/perguntas`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // obterPorId(id) {
    //     let url = `${api}/mensagens/${id}`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterRespostas(tipo) {
        let url = `${api}/pesquisas/respostas?tipo=${tipo}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterResposta(respostaId) {
        let url = `${api}/pesquisas/respostas/${respostaId}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviar(respostas) {
        let url = `${api}/pesquisas/responder`
        return axiosJwt
            .post(url, respostas)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

    // lerNaoLerMensagem(mensagemId) {
    //     let url = `${api}/mensagens/${mensagemId}`
    //     return axiosJwt.patch(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // excluirMensagem(mensagemId) {
    //     let url = `${api}/mensagens/${mensagemId}`
    //     return axiosJwt.delete(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // }
}
